var map = {
	"./assets/icons/account_v03_icona_apple.png": "7010",
	"./assets/icons/account_v03_icona_facebook.png": "25d1",
	"./assets/icons/account_v03_icona_mail.png": "4d71",
	"./assets/icons/android-chrome-192x192.png": "e40a",
	"./assets/icons/android-chrome-256x256.png": "6ab3",
	"./assets/icons/apple-touch-icon.png": "99a0",
	"./assets/icons/favicon-16x16.png": "0d9e",
	"./assets/icons/favicon-32x32.png": "d254",
	"./assets/icons/mstile-150x150.png": "0404",
	"./assets/images/Apple_icon.png": "1d83",
	"./assets/images/Apple_pay_icon.png": "9fcc",
	"./assets/images/Facebook_Icon.png": "e6d6",
	"./assets/images/Google_pay_icon.png": "63df",
	"./assets/images/Smart_Tales_Icon.png": "afdc",
	"./assets/images/Smart_Tales_Logo.png": "514e",
	"./assets/images/banners_img/banner_account.png": "6295",
	"./assets/images/banners_img/banner_login.png": "1f0e",
	"./assets/images/banners_img/banner_password.png": "1347",
	"./assets/images/banners_img/banner_promocode.png": "6612",
	"./assets/images/banners_img/banner_signup.png": "b2b2",
	"./assets/images/best_value_box.png": "5d00",
	"./assets/images/credit_amex_icon.png": "af77",
	"./assets/images/credit_mastercard_icon.png": "b916",
	"./assets/images/credit_visa_electron_icon.png": "b92a",
	"./assets/images/credit_visa_icon.png": "ee4a",
	"./assets/images/en_US.png": "6ffb",
	"./assets/images/home/Smart_Tales_Icon.png": "8778",
	"./assets/images/home/Smart_Tales_Logo.png": "76d3",
	"./assets/images/home/android_en.png": "574a",
	"./assets/images/home/android_it.png": "5337",
	"./assets/images/home/header_landing.png": "6430",
	"./assets/images/home/ios_en.png": "de42",
	"./assets/images/home/ios_it.png": "ddab",
	"./assets/images/home/smart_tales.png": "0c5a",
	"./assets/images/home/smart_tales_blue.png": "40f0",
	"./assets/images/home/smart_tales_logo_basic.png": "0d83",
	"./assets/images/it_IT.png": "ad4f",
	"./assets/images/lock_icon.png": "9d8c",
	"./assets/images/money_back_icon.png": "b93c",
	"./assets/images/mosquita_create_account.png": "a0cd",
	"./assets/images/mosquita_error.png": "4a51",
	"./assets/images/mosquita_forgotten_password.png": "30a3",
	"./assets/images/mosquita_generic_error.png": "72b6",
	"./assets/images/mosquita_promo_code.png": "24ee",
	"./assets/images/mosquita_rocket.png": "441b",
	"./assets/images/powered_by_stripe_icon.png": "0399",
	"./assets/images/settings_de.png": "4dc6",
	"./assets/images/settings_en.png": "8961",
	"./assets/images/settings_es.png": "dc8b",
	"./assets/images/settings_fr.png": "d4f7",
	"./assets/images/settings_it.png": "81ad",
	"./assets/images/thick_icon.png": "efb5",
	"./assets/logo.png": "cf05"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4ca9";